// src/Helpers/KeywordUtils.js
import { useState } from 'react';
import keywordsData from '../Data/keywordsData';
import React from 'react';

export const useTooltip = () => {
    const [tooltipVisible, setTooltipVisible] = useState(false);
    const [tooltipContent, setTooltipContent] = useState('');
    const [tooltipPosition, setTooltipPosition] = useState({ x: 0, y: 0 });

    return {
        tooltipVisible,
        setTooltipVisible,
        tooltipContent,
        setTooltipContent,
        tooltipPosition,
        setTooltipPosition,
    };
};

export const findAndDisplayKeyword = (rule, selectedData, setTooltipContent) => {
    const lowercaseRule = rule.toLowerCase();
    let keyword = keywordsData.find((keywordObj) => keywordObj.name.toLowerCase() === lowercaseRule);

    if (rule === 'Leader' && selectedData?.CORE && selectedData.CORE.includes('Leader')) {
        const leaderValues = selectedData.LEADER || [];
        keyword = { value: leaderValues.join(', '), isLeader: true };
    }

    setTooltipContent(keyword
        ? `${keyword.name.toUpperCase()}: "${keyword.value}"`
        : `Keyword "${rule}" not found.`);
};

export const formatKeywordsWithCommas = (keywords, handleSpecialRuleClick) => {
    if (!keywords || keywords.length === 0) {
        return null;
    }

    return keywords.map((keyword, index) => {
        const lowercaseKeyword = keyword.toLowerCase();
        const isClickable = keywordsData.find((keywordObj) => keywordObj.name.toLowerCase() === lowercaseKeyword);
        const isLeader = lowercaseKeyword === 'leader';

        return (
            <React.Fragment key={index}>
                {index > 0 && <span className="comma">, </span>}
                <button type="button"
                        className={`underline  underline-offset-2  decoration-slate-400  font-medium  text-xs  uppercase  tracking-wide ${isClickable ? 'clickable-keyword' : ''} ${isLeader ? 'leader-keyword' : ''}`}
                        onClick={(event) => handleSpecialRuleClick(event, keyword)}
                >
                    {keyword}
                </button>
            </React.Fragment>
        );
    });
};

export const handleTooltip = (event, rule, selectedData, setTooltipContent, setTooltipPosition, setTooltipVisible, additionalData) => {
    event.stopPropagation();
    findAndDisplayKeyword(rule, selectedData, setTooltipContent);

    if (additionalData) {
        const match = rule.match(/\d+\+?/);
        const number = match ? match[0] : "";
        const lowercaseRule = rule.toLowerCase().replace(/\d+\+?/, "").trim();

        const keyword = keywordsData.find((keywordObj) => keywordObj.name.toLowerCase() === lowercaseRule);

        let tooltipContentWithValue = keyword.value
            .replace("‘x+’", number)
            .replace("‘x’", number);
        tooltipContentWithValue = tooltipContentWithValue.replace(/\\n/g, "\n");

        setTooltipContent(keyword
            ? `${keyword.name.toUpperCase()}: "${tooltipContentWithValue}"`
            : `Keyword "${rule}" not found.`);
    }

    const rect = event.target.getBoundingClientRect();
    const scrollLeft = document.documentElement.scrollLeft;
    const scrollTop = document.documentElement.scrollTop;
    setTooltipPosition({ x: rect.left + scrollLeft, y: rect.top + scrollTop });
    setTooltipVisible(true);
};